<template>
  <div
    :class="[$style.base, { [$style.isClosable]: isClosable }]"
    v-test="'alert'"
  >
    <div v-test="'alert-close'" :class="$style.close" @click="onCloseClick">
      <IconClose v-if="isClosable" />
    </div>
    {{ customAlert ? customAlert : $t('general.block_new_customers') }}
  </div>
</template>

<script>
import IconClose from '@/components/IconClose.vue';

export default {
  props: {
    customAlert: {
      type: String,
      required: false
    },
    isClosable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    IconClose
  },
  methods: {
    onCloseClick() {
      this.$emit('onCloseClick');
    }
  }
};
</script>

<style lang="scss" module>
.base {
  position: relative;
  padding: $spacing - 2px $spacing $spacing + 2px;
  background-color: #fff5d4;
  z-index: 2;

  &.isClosable {
    padding: $spacing - 2px 50px $spacing + 2px $spacing;
  }
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 50px;
  height: 46px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
